<template>
    <div class="positionnement-offre">
        <div class="tle-row">
            <div class="tle-col one-third">
                <div v-if="editor.mode === 'editing'">
                Prix d'un <el-select
                    behavior="dialog"
                    :parent_data="active_study.etudeData.gie.sectionSynthesePreconisations"
                    property="indexSelectedType"
                    :options="Object.values(active_study.etudeData.gie.sectionSynthesePreconisations.synthese_preconisations_table).map((loyer, index) => ({label: loyer.type, value: index}))"
                    :editable="true"
                    dense
                    />
                {{selectedValue.prix_unit}} €
                </div>
                <div v-else>
                    <el-square
                    :parent_data="
                        selectedValue
                    "
                    property="prix_unit"
                    :label= "'Prix d\'un ' +selectedValue.type"
                    format="string"
                    suffix="€"
                    />
                </div>
           </div>
            <div class="tle-col one-third self-center">
                <el-textarea
                :parent_data="
                    active_study.etudeData.gie.sectionSynthesePreconisations
                "
                property="positionnement_menages_pourcent"
                :editable="true"
                suffix="%"
                :style="{ display: editor.mode !== 'editing' ? 'inline' : undefined }"
                /> des ménages sont en capacité d'acheter un {{selectedValue.type}} dans cette résidence
            </div>
        </div>
    </div>
</template>
<script>

import { mapGetters } from "vuex";

import PageMixin from "@/components/study/editor/pages/page.mixin.js";
export default {
	mixins: [PageMixin],
	computed: {
		...mapGetters([
			"active_study",
			"editor",
		]),
		selectedValue: function () {
			let index = this.active_study.etudeData.gie.sectionSynthesePreconisations.indexSelectedType;
			if(typeof index==="undefined"){
				this.active_study.etudeData.gie.sectionSynthesePreconisations.indexSelectedType=2;
				index=2;
				// Assignation redondante de la valeur par défaut pour les anciennes études chez qui cette valeur n'existe pas encore
			}
			return this.active_study.etudeData.gie.sectionSynthesePreconisations.synthese_preconisations_table[index];
		}
	},
};
</script>
<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'
</style>
